export default function () {

    const store = {
        url: null,
        clientId: null,

        currentCount: 0,
        totalCount: 0,

        userList: [],
        departmentList: [],
        searchOptionNext: null,

        isFilterVisible:false,

        multiPhoneSupport:true,

        noInitUsers : false,
        defaultDepartment:"",

        //Caption
        searchPlaceholderCaption:"Søk på navn, avdeling, seksjon e.l.",
        selectDepartmentCaption:"Velg avdeling",
        selectSectionCaption:"Velg seksjon",

        searchOption: {
            "Search": {
                "TypeOfSearch": "Contains",
                "SearchFields": [
                    "SurName",
                    "GivenName",
                    "Title",
                    "Department",
                    "Section",
                    "Phone"]
            },
            "Department": {
                "DepartmentId": "",
                "SectionId": ""
            },
            "Sort": {
                "SortField": "",
                "SortDirection": ""
            },
            "Pageing": {
                "PageSize": 50
            },
            "SearchQuery": ""
        }
    };

    return {
        set(key, value) {
            store[key] = value;
        },

        get(key) {
            if (!key) return store;
            return store[key];
        }
    }
};